<template>
	<Popup
		v-model="selfDisplay"
		title="充值记录"
		:confirmBtnDisplay="false"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row" style="padding: 0;">
				<el-date-picker
					v-model="startTime"
					:editable="false"
					class="b_inp"
					placeholder="开始时间"
					type="datetime"
					value-format="yyyy-MM-dd HH:mm:ss"
					@change="handleTimeChange"
				>
				</el-date-picker>
				<el-date-picker
					v-model="endTime"
					:editable="false"
					class="b_inp"
					placeholder="结束时间"
					type="datetime"
					value-format="yyyy-MM-dd HH:mm:ss"
					style="margin-left: 20px;"
					@change="handleTimeChange"
				>
				</el-date-picker>
			</div>
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tabData"
					style="width: 100%"
				>
					<el-table-column
						prop="date"
						label="时间"
					>
					</el-table-column>
					<el-table-column
						prop="action"
						label="操作"
					>
					</el-table-column>
					<el-table-column
						v-if="type == 1"
						prop="operated"
						label="被操作人"
					>
					</el-table-column>
					<el-table-column
						prop="product"
						label="产品"
					>
					</el-table-column>
					<el-table-column
						prop="detail"
						label="明细"
					>
					</el-table-column>
					<el-table-column
						prop="operater"
						label="操作人"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="page"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end-->
		</div>
	</Popup>
</template>

<script>
	import Api from "../../../../../api/index.js"
	import { mapState } from "vuex"
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			id: {
				type: [Number, String],
				required: true
			},
			code: {
				type: [String],
				required: true
			},
			type: {
				type: [Number, String],
				required: true
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data () {
			return {
				loading: false,
				selfDisplay: false,
				startTime: '',
				endTime: '',
				page: 1,
				total: 0,
				tabData: []
			}
		},
		computed: {
			...mapState(['allProduct'])
		},
		methods: {
			// 获取数据
			getData () {
				const that = this;
				that.loading = true;
				var _requestData = {
					endTime: that.endTime,
					id: null,
					limit: 10,
					oneCategory: 1,
					pageNum: that.page,
					startTime: that.startTime,
					twoCategory: 0,
					type: that.type,
					ucode: that.code,
					uenterpriseId: that.id,
					versionFlag: null
				};
				Api.getOrganizationRechargeConsumeRecord(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.totalItems;
						that.tabData = [];
						var _data = res.data.data.data;
						for (var i = 0;i < _data.length;i++) {
							for (var ii = 0;ii < that.allProduct.length;ii++) {
								if (_data[i].uversionFlag == that.allProduct[ii].id) {
									var _action = '',
										_o = {};
									if (_data[i].ucategory == 1) {
										_action = '充值';
									} else if (_data[i].ucategory == 2) {
										_action = '赠送';
									} else if (_data[i].ucategory == 3) {
										_action = '扣除返还';
									}
									_o.date = _data[i].ucreateTs ? _data[i].ucreateTs.split(" ")[0] : "";
									_o.action = _action;
									_o.operated = _data[i].operator ? _data[i].operator : '/';
									_o.product = that.allProduct[ii].name;
									_o.detail = _data[i].utime;
									_o.operater = _data[i].username ? _data[i].username : '/';
									that.tabData.push(_o);
								}
							}
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 改变时间
			handleTimeChange () {
				this.compareTime();
				this.resetData();
				this.getData();
			},
			// 充值记录页码改变
			handlePageChange (page) {
				if (this.page != page) {
					this.page = page;
					this.getData();
				}
			},
			// 还原需要还原的数据
			resetData () {
				this.page = 1;
			},
			// 比较开始时间和结束时间
			compareTime () {
				if (this.startTime && this.endTime) {
					var startTime = new Date(this.startTime).getTime(),
						endTime = new Date(this.endTime).getTime();
					if (endTime < startTime) {
						this.endTime = '';
						this.$message.warning('结束时间不能小于开始时间');
					}
				}
			}
		},
		watch: {
			display (newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay (newVal) {
				this.$emit("changeDisplay", newVal);
				newVal && this.getData();
				if (!newVal) {
					this.loading = false;
					this.startTime = '';
					this.endTime = '';
					this.page = 1;
					this.total = 0;
					this.tabData = [];
				}
			}
		}
	}
</script>

<style>
</style>
